// extracted by mini-css-extract-plugin
export default {"privacy":"privacyPolicy_privacy__5dqxX","sub_privacy":"privacyPolicy_sub_privacy__ScgI9","privacy_content":"privacyPolicy_privacy_content__OpuWs"};